import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import Banner from '../../components/products/Banner';
import Product from '../../components/products'

const Products = () => {

    useEffect(() => {
        window.scrollTo({top:0, left:0})
    }, [])


    return (
        <Grid container style={{width:'100%', justifyContent:'center'}}>
            <Banner img={'/assets/images/product-banner.jpg'} title={'Bridging Technical Excellence and Human Wellbeing'} />
            <Product />
        </Grid>
    )

}

export default Products;